<nav class="sidebar sidebar-offcanvas" id="sidebar">
  <ul class="nav">
    <li class="nav-item" [ngClass]="{ 'active': home.isActive }">
      <a class="nav-link" routerLink="/property/home" routerLinkActive="active" #home="routerLinkActive">
        <i class="ti-home menu-icon"></i>
        <span class="menu-title text-shadow">หน้าหลัก</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : owner.isActive}">
      <a class="nav-link" (click)="assetCollapsed = !assetCollapsed" routerLinkActive="active"
        #owner="routerLinkActive">
        <i class="fa fa-map-o menu-icon"></i>
        <span class="menu-title text-shadow">แผนที่ภาษีและทะเบียนทรัพย์สิน</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="asset" [ngbCollapse]="!assetCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="text-white text-center">ค้นหาข้อมูล
          <li>
            <hr class="p-0 m-0 bg-white">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/property/home']">
              ที่ดิน/สิ่งปลูกสร้าง/ป้าย</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/property/condoManage']">
              อาคารชุด/คอนโดมิเนียม</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/general/owner']"
              [routerLink]="['/general/municipal']" routerLinkActive="active"
              #owner="routerLinkActive">เจ้าของทรัพย์สิน</a>
          </li>
          <hr class="p-0 m-0 bg-white">
          <!-- <li class="text-white">------------ทะเบียนรายการ ------------</li> -->
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/owner/list']">ทะเบียนรายการ
              เจ้าของทรัพย์สิน</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/land/list']">ทะเบียนรายการ แปลงที่ดิน</a>
          </li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/building/list']">ทะเบียนรายการ
              สิ่งปลูกสร้าง</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/condo/list']">ทะเบียนรายการ
              ห้องคอนโดมิเนียม</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/signboard/list']">ทะเบียนรายการ ป้าย</a></li>
          <hr class="p-0 m-0" style="background-color:white">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/dailyEdit']">รายงานการปรับข้อมูลรายวัน</a>
          </li>
          <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['/dol/m10']">นำเข้าข้อมูลการเปลี่ยนแปลงที่ดิน <br>(มาตรา 10)</a></li> -->
          <li class="nav-item"><a class="nav-link" [routerLink]="['/map']">ระบบสารสนเทศภูมิศาสตร์</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report']">รายงานสรุปข้อมูลทะเบียนทรัพย์สิน</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item"
      [ngClass]="{ 'active' : assess.isActive ||assess1.isActive ||assess2.isActive ||assess3.isActive || assess4.isActive ||pp3.isActive || pp7.isActive || pp7List.isActive} || docwarning.isActive">
      <a class="nav-link" (click)="assessCollapsed = !assessCollapsed">
        <i class="fa fa-calculator menu-icon"></i>
        <span class="menu-title text-shadow">การจัดเก็บรายได้</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="assess" [ngbCollapse]="!assessCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="text-white text-center">ภาษีที่ดินและสิ่งปลูกสร้าง</li>
          <hr class="p-0 m-0 bg-white">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/assess']" routerLinkActive="active"
              #assess="routerLinkActive">การประเมินอัตราภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/assess/list']" routerLinkActive="active"
              #assess1="routerLinkActive">รายการการประเมินภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/income/tax']" routerLinkActive="active"
              #assess2="routerLinkActive">การรับชำระภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/income/receive']" routerLinkActive="active"
              #assess3="routerLinkActive">รายการรับชำระภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/income/docwarning']" routerLinkActive="active"
              #assess4="routerLinkActive">หนังสือแจ้งเตือนชำระภาษี</a></li>
          <hr class="p-0 m-0 bg-white">
          <li class="text-white text-center">ภาษีป้าย</li>
          <hr class="p-0 m-0 bg-white">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/sign/pp3']" routerLinkActive="active"
              #pp3="routerLinkActive">ยื่นแบบ / การประเมินอัตราภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/sign/pp7']" routerLinkActive="active"
              #pp7="routerLinkActive">การรับชำระภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/sign/pp7List']" routerLinkActive="active"
              #pp7List="routerLinkActive">รายการรับชำระภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/sign/docwarning']" routerLinkActive="active"
              #docwarning="routerLinkActive">หนังสือแจ้งเตือนชำระภาษี</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : report.isActive} ">
      <a class="nav-link" (click)="reportCollapsed = !reportCollapsed" [attr.aria-expanded]="reportCollapsed"
        aria-controls="report" routerLinkActive="active" #report="routerLinkActive">
        <i class="fa fa-file menu-icon"></i>
        <span class="menu-title text-shadow">หนังสือราชการ</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="report" [ngbCollapse]="!reportCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/pds1']" routerLinkActive="active"
              #pds1="routerLinkActive">ราคาประเมินทุนทรัพย์ของที่ดิน<br>และสิ่งปลูกสร้าง ภ.ด.ส.1</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/pds2']" routerLinkActive="active"
              #pds2="routerLinkActive">ราคาประเมินทุนทรัพย์ห้องชุด<br>ตามกฏหมายว่าด้วยอาคารชุด ภ.ด.ส.2</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/pds3']" routerLinkActive="active"
              #pds3="routerLinkActive">แบบบัญชีรายการที่ดินและสิ่งปลูกสร้าง<br> ภ.ด.ส.3</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/pds4']" routerLinkActive="active"
              #pds4="routerLinkActive">แบบบัญชีรายการห้องชุด ภ.ด.ส.4</a></li>
        </ul>
      </div>
    </li>

    <li class="nav-item"
      [ngClass]="{ 'active' : kk1.isActive || kk2.isActive || notfound.isActive||noLandPrice.isActive} ">
      <a class="nav-link" (click)="report2Collapsed = !report2Collapsed" [attr.aria-expanded]="report2Collapsed"
        aria-controls="report">
        <i class="fa fa-file menu-icon"></i>
        <span class="menu-title text-shadow">แบบรายงาน</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="report2" [ngbCollapse]="!report2Collapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/kk1']" routerLinkActive="active"
              #kk1="routerLinkActive">ผู้อยู่ในข่ายเสียภาษีที่ดินและสิ่งปลูกสร้าง<br>(ภ.ด.ส.7,8)</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/payment/kk2']" routerLinkActive="active"
              #kk2="routerLinkActive">ผู้อยู่ในข่ายแต่ไม่มาชำระภาษี</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/pds3/notfound']" routerLinkActive="active"
              #notfound="routerLinkActive">แปลงที่ดิน ที่ไม่ได้ประกาศ ภ.ด.ส.3</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/noLandPrice']" routerLinkActive="active"
              #noLandPrice="routerLinkActive">แปลงที่ดินที่ยังไม่ได้กำหนดราคา<br>ทุนทรัพย์ที่ดิน</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/landInTax']" routerLinkActive="active"
              #landInTax="routerLinkActive">แปลงที่ดินที่อยู่ในข่ายเสียภาษี<br>ที่ดินและสิ่งปลูกสร้าง</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/ownerInTax']" routerLinkActive="active"
              #ownerInTax="routerLinkActive">ผู้อยู่ในข่ายเสียภาษีที่ดินและสิ่งปลูกสร้าง</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/info']" routerLinkActive="active"
              #infoReport="routerLinkActive">รายงานจัดส่งระบบ Info</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/report/lpa']" routerLinkActive="active"
              #infoReport="routerLinkActive">รายงาน LPA</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{'active': municipal.isActive || taxSetting.isActive }">
      <a class="nav-link" (click)="generalCollapsed = !generalCollapsed">
        <i class="ti-settings menu-icon"></i>
        <span class="menu-title">การจัดการทั่วไป</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" [ngbCollapse]="!generalCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"><a class="nav-link" [routerLink]="['/general/municipal']" routerLinkActive="active"
              #municipal="routerLinkActive">ข้อมูลองค์กรปกครองส่วนท้องถิ่น</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/general/tax-setting']" routerLinkActive="active"
              #taxSetting="routerLinkActive">ค่าตั้งต้นแผนที่ภาษีและทะเบียนทรัพย์สิน</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/general/file-setting']" routerLinkActive="active"
              #taxSetting="routerLinkActive">ตั้งค่าไฟล์เอกสาร</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/general/users']">กำหนดสิทธิของผู้ใช้งาน</a></li>
          <li class="nav-item"><a class="nav-link"
              [routerLink]="['/general/building-setting']">ราคาประเมินสิ่งปลูกสร้าง</a>
          </li>
          <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['/general/sign-setting']">อัตราภาษีป้าย</a></li> -->
          <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['/dol']">นำเข้าไฟล์ข้อมูลที่ดิน
              (ได้รับจากกรมที่ดิน)</a> -->
          <!-- </li> -->
          <li class="nav-item"><a class="nav-link"
              [routerLink]="['/general/landPrice-import']">นำเข้าไฟล์ข้อมูลราคาประเมินที่ดิน</a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="['/dol/m10']">นำเข้าไฟล์มาตรา 10</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" (click)="logout()">
        <i class="ti-power-off menu-icon"></i>
        <span class="menu-title">ออกจากระบบ</span>
      </a>
    </li>
    <li class="nav-item justify-content-center text-center">
      <hr class="p-0 m-0 mb-2">
      <span style="color:white;padding:0px;margin:0px;">L</span><span
        style="color:rgb(240, 27, 20);padding:0px;margin:0px;">T</span><span
        style="color:rgb(236, 184, 12);padding:0px;margin:0px;">a</span><span
        style="color:white;padding:0px;margin:0px;">x</span>
      <p class="text-white" style="font-size:0.55rem;">{{_version}}</p>
    </li>
  </ul>

</nav>